module.exports = __webpack_public_path__ + "static/media/location-maps-letter-c-arrow.5f366428.png";